<template>
    <div>
        <geometry-element
                :selectable="movingElement"
                :movable="isHexagonalModeling ? false : (!isReadOnly && movingElement)"
                :resizable="isHexagonalModeling ? false : (!isReadOnly && movingElement && isEditElement)"
                :deletable="isHexagonalModeling ? false : (!isReadOnly && isEditElement)"
                connectable
                :id.sync="elementCoordinate.id"
                :x.sync="elementCoordinate.x"
                :y.sync="elementCoordinate.y"
                :width.sync="elementCoordinate.width"
                :height.sync="elementCoordinate.height"
                :customMoveActionExist="isCustomMoveExist"
                v-on:customMoveAction="delayedMove"
                v-on:moveShape="onMoveShape"

                v-on:removeShape="onRemoveShape"
                v-on:dblclick="openPanel"
                v-on:selectShape="selectedActivity"
                v-on:deSelectShape="deSelectedActivity"
                v-on:rotateShape="onRotateShape"
                v-on:addedToGroup="onAddedToGroup"
                :label.sync="getFieldDescriptors ? '': namePanel"
                :image.sync="setImg"
                :_style="{
                'label-angle':value.elementView.angle,
                'font-weight': 'bold', 'font-size': '16',
                }"
        >
            <!--v-on:dblclick="$refs['dialog'].open()"-->

            <sub-elements v-if="isHexagonalModeling">
<!--                <geometry-polygon-->
<!--                        :vertices="[ [30,20], [70,20], [80, 50], [70,80], [30,80], [20,50],[30,20] ]"-->
<!--                        :_style="{-->
<!--              'fill-r': 1,-->
<!--              'fill-cx': .1,-->
<!--              'fill-cy': .1,-->
<!--              'stroke-width': 1.4,-->
<!--              'stroke': '#00ff0000',-->
<!--              'fill': '#F8D454',-->
<!--              'fill-opacity': 1,-->
<!--              'vertical-align': 'top',-->
<!--              'font-weight': 'bold',-->
<!--              'font-size': '16',-->
<!--               'r': '1'}"-->
<!--                ></geometry-polygon>-->
            </sub-elements>

            <sub-elements v-else>
                <geometry-rect
                        v-if="movingElement"
                        :_style="{
          'fill-r': 1,
          'fill-cx': .1,
          'fill-cy': .1,
          'stroke-width': 1.4,
          'stroke': '#F8D454',
          fill: '#F8D454',
          'fill-opacity': .5,
          r: '1',
        }"
                >
                </geometry-rect>

                <geometry-rect
                        v-else
                        :_style="{
          'fill-r': 1,
          'fill-cx': .1,
          'fill-cy': .1,
          'stroke-width': 1.4,
          'stroke': '#F8D454',
          fill: '#F8D454',
          'fill-opacity': .3,
          r: '1',
        }"
                >
                </geometry-rect>
            </sub-elements>



            <sub-elements v-if="!isHexagonalModeling" v-for="(index) in newEditUserImg.length">
                <image-element
                        v-bind:image="newEditUserImg[index-1].picture"
                        :sub-width="'24px'"
                        :sub-height="'24px'"
                        :sub-right="(10*(index-1))+'px'"
                        :sub-bottom="value.elementView.height"
                >
                </image-element>
            </sub-elements>

            <sub-elements>
                <geometry-point
                        :coordinate="[95,5]"
                        :_style="statusCompleteStyle">
                </geometry-point>

                <!--title-->
                <text-element
                        v-if="!isHexagonalModeling"
                        :sub-width="'100%'"
                        :sub-height="titleH"
                        :sub-top="0"
                        :sub-left="0"
                        :text="value.classReference ? value.classReference : '<< Aggregate >>'">
                </text-element>

                <text-element
                        v-if="getFieldDescriptors && !isHexagonalModeling"
                        :sub-width="'100%'"
                        :sub-height="subjectHeight"
                        :sub-top="subjectTop"
                        :sub-left="0"
                        :subStyle="{'font-size': '16px', 'font-weight': 'bold'}"
                        :text="getNamePanel">
                </text-element>

                <!--                <geometry-line :from="getLineFromTo.from" :to="getLineFromTo.to"></geometry-line>-->

                <text-element
                        class="discStyle"
                        v-if="getFieldDescriptors && !isHexagonalModeling"
                        :sub-width="'120%'"
                        :sub-height="detailHeight"
                        :sub-top="detailTop"
                        :sub-left="detailLeft"
                        :subStyle="{'font-size': '12px', 'text-anchor':'start'}"
                        :text="getFieldDescriptors">
                </text-element>

                <image-element
                        v-if="showValidation"
                        v-bind:image="showValidationImg"
                        :sub-width="'20px'"
                        :sub-height="'20px'"
                        :sub-right="'5px'"
                        :sub-bottom="'5px'"
                >
                </image-element>
                <storming-sub-controller :type="value._type" :value="value"
                                         :readOnly="isReadOnly"></storming-sub-controller>
            </sub-elements>
        </geometry-element>


        <aggregate-definition-panel
                v-if="propertyPanel"
                v-model="value"
                :readOnly="!isEditElement"
                :newEditUserImg="newEditUserImg"
                :image="image"
                :validationLists="filteredElementValidationResults"
                @close="closePanel"
                @changedPanelValue="changedPanelValue"
        ></aggregate-definition-panel>

    </div>
</template>

<script>
    import AggregateDefinitionPanel from "../panels/AggregateDefinitionPanel";
    import Element from './EventStormingModelElement'

    var changeCase = require('change-case');
    var pluralize = require('pluralize');
    var _ = require('lodash')

    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    export default {
        mixins: [Element],
        name: 'aggregate-definition',
        props: {},
        components: {
            AggregateDefinitionPanel
        },
        watch: {
            "value.aggregateRoot": {
                deep: true,
                handler: _.debounce(function (newVal, oldVal) {
                    var me = this
                    me.validate(null, false)
                    me.refresh()
                }, 200)
            },
            // "value.commands": {
            //     deep: true,
            //     handler:function (newVal) {
            //         var me = this
            //         console.log(newVal)
            //     }
            // },
        },
        computed: {
            subjectTop() {
                return 30
            },
            subjectHeight() {
                return 8
            },
            detailHeight() {
                var count = null
                if(this.value.elementView.height <= 270){
                    count = this.aggfieldDescriptorsCount
                } else if(this.value.elementView.height > 270){
                    count = this.value.aggregateRoot.fieldDescriptors.length
                }
                return this.subjectHeight + (count * 5)
            },
            detailLeft() {
                var width = this.value.elementView.width * 0.1
                return width
            },
            detailTop() {
                return this.subjectTop + this.detailHeight
            },
            getFieldDescriptors() {
                if(this.isHexagonalModeling){
                    return ' '
                }

                if (this.value.aggregateRoot.fieldDescriptors) {

                    if (this.value.aggregateRoot.fieldDescriptors.length == 1
                        && this.value.aggregateRoot.fieldDescriptors[0].name == 'id') {
                        return false
                    }

                    var text = ''
                    var value = 0
                    if(this.value.elementView.height <= 100){
                        value = 42
                    } else if(this.value.elementView.height <= 150){
                        value = 30
                    } else if(this.value.elementView.height <= 270){
                        value = 23
                    } else if(this.value.elementView.height > 270){
                        value = 17
                    }
                    var y = Math.ceil(this.value.elementView.height/value)
                    this.aggfieldDescriptorsCount = y
                    if(this.value.aggregateRoot.fieldDescriptors.length > y){
                        for(var i = 0; i <= y; i++){
                            if(i == y) text = text + 'ㆍ ' + this.value.aggregateRoot.fieldDescriptors[i].name + '  ...'
                            else text = text + 'ㆍ ' + this.value.aggregateRoot.fieldDescriptors[i].name + '\n'
                        }
                    } else {
                        this.value.aggregateRoot.fieldDescriptors.forEach(function (field) {
                            text = text + 'ㆍ ' + field.name + '\n'
                        })
                    }
                    return text
                }
                return null


            },
            className() {
                return 'org.uengine.modeling.model.Aggregate'
            },
            createNew(elementId, x, y, width, height, description, label) {
                return {
                    _type: 'org.uengine.modeling.model.Aggregate',
                    name: '',
                    oldName: '',
                    namePlural: '',
                    namePascalCase: '',
                    nameCamelCase: '',
                    author: null,
                    description: null,
                    elementView: {
                        '_type': 'org.uengine.modeling.model.Aggregate',
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': 100,

                        'height': 100,
                        'style': JSON.stringify({})
                    },
                    boundedContext: {},
                    aggregateRoot: {
                        _type: "org.uengine.modeling.model.AggregateRoot",
                        fieldDescriptors:[
                            {
                                _type: "org.uengine.model.FieldDescriptor",
                                name: "id",
                                className: "Long",
                                nameCamelCase: 'id',
                                namePascalCase: 'Id',
                                isKey: true
                            }
                        ],
                        entities: { 'elements': {}, 'relations': {} },
                        operations: [],
                    },
                    events: [],
                    commands: [],
                }

            },

        },
        data: function () {
            return {
                aggfieldDescriptorsCount: 0,
                titleH: (this.value.classReference ? 60 : 30),
                reference: this.value.classReference != null,
                referenceClassName: this.value.classReference,
                // umlCanvas: null,
            };
        },
        created: function () {
            var me = this

            if(me.value.aggregateRoot.fieldDescriptors == undefined) {
                me.value.aggregateRoot.fieldDescriptors = [
                    {
                        _type: "org.uengine.model.FieldDescriptor",
                        name: "id",
                        className: "Long",
                        nameCamelCase: 'id',
                        namePascalCase: 'Id',
                        isKey: true
                    }
                ]
            }

            if(me.value.aggregateRoot.entities == undefined) {
                me.value.aggregateRoot.entities =  { 'elements': {}, 'relations': {} }
            } else {
                if(me.value.aggregateRoot.entities.elements && Object.values(me.value.aggregateRoot.entities.elements).length > 0) {
                    Object.values(me.value.aggregateRoot.entities.elements).forEach(function(item) {
                        if(item) {
                            if(item.isVO) {
                                item._type = 'org.uengine.uml.model.vo.Class';
                            }
                        }
                    })
                }
            }
            if(me.value.aggregateRoot.operations) {
                me.value.aggregateRoot.operations.forEach(function(item) {
                    if(item.returnType == "") {
                        item.returnType = "void"
                    }
                })
            } else {
                me.value.aggregateRoot.operations = []
            }
        },
        mounted: function () {
            var me = this

            // me.umlCanvas = new BroadcastChannel('umlCanvas_' + me.value.elementView.id)
            // me.umlCanvas.onmessage = res => {
            //     if(res.data) {
            //         if(res.data != 'loadClass') {
            //             var parseAggregate = JSON.parse(res.data)
            //             me.addAggregateRoot(parseAggregate)
            //             // me.propertyPanel = true
            //         } else {
            //             var aggregateRoots = [];
            //             aggregateRoots.push(me.value);
            //             me.umlCanvas.postMessage(JSON.stringify(aggregateRoots))
            //         }
            //     }
            // }

            Object.values(me.canvasbase.value.elements).forEach(function(el) {
                if(el) {
                    if(el._type.endsWith("Aggregate") 
                            && el.boundedContext.id == me.value.boundedContext.id
                            && Object.keys(me.value.aggregateRoot.entities.elements).length < 1) {
                        me.value.aggregateRoot.entities = el.aggregateRoot.entities;
                    }
                }
            })

            me.$EventBus.$on(`${me.value.elementView.id}`, function (obj) {
                // add relation
                if(obj.action == 'addRelation' && obj.element.relationView && obj.element.sourceElement && obj.element.sourceElement.elementView.id == me.value.elementView.id) {
                    var isNew = true
                    Object.values(me.value.aggregateRoot.entities.elements).forEach(function(el , idx) {
                        if(el) {
                            if(el.isVO && el.namePascalCase == obj.element.targetElement.namePascalCase + "Id") {
                                isNew = false
                            }
                        }
                    })
                    if(isNew) {
                        me.addAggRelation(obj.element)
                    }

                }
                
                // delete relation
                if(obj.action == 'deleteRelation' 
                    && obj.element.relationView 
                    && obj.element.sourceElement 
                    && obj.element.sourceElement.elementView.id == me.value.elementView.id
                ) {
                    me.deleteAggRelation(obj.element)
                }
                
                // update entities
                if(obj.action == 'updateEntities' && obj.entities) {
                    console.log(obj.action)
                    me.addAggregateRoot(obj.entities);
                }
            })

        },
        methods: {
            addAggregateRoot(entities) {
                var me = this;

                if(entities) {
                    if(me.canvasbase.initLoad){
                        me.canvasbase.changedByMe = true;
                    }

                    me.value.aggregateRoot.entities = entities;

                    if(entities.elements) {
                        Object.keys(entities.elements).forEach(function (key) {
                            if( key
                                && entities.elements[key]
                                && entities.elements[key].parentId == me.value.elementView.id
                                && entities.elements[key]._type != 'ClassGroup'
                            ) {
                                me.value.aggregateRoot.operations = entities.elements[key].operations;
                                me.value.aggregateRoot.fieldDescriptors = entities.elements[key].fieldDescriptors;
                                me.value.aggregateRoot.fieldDescriptors.forEach(function (attr) {
                                    attr['_type'] = "org.uengine.model.FieldDescriptor";
                                })
                            }
                        })
                    }
                }
                me.refresh();
            },
            
            addAggRelation(element) {
                var me = this;
                var attr = {};
                var isNew = true;
                var toName = element.targetElement.name;

                if(element.targetElement.boundedContext.id == me.value.boundedContext.id) {
                    // 같은 BC
                    attr = {
                        "_type": "org.uengine.model.FieldDescriptor",
                        "name": changeCase.camelCase(toName),
                        "className": changeCase.pascalCase(toName),
                        "isKey": false,
                        "namePascalCase": changeCase.pascalCase(toName),
                        "nameCamelCase": changeCase.camelCase(toName),
                        "isVO": false,
                        "label": "- "+ changeCase.camelCase(toName) + ": " + changeCase.pascalCase(toName),
                        "referenceClass": changeCase.pascalCase(toName),
                    }
                } else {
                    // 다른 BC
                    attr = {
                        "_type": "org.uengine.model.FieldDescriptor",
                        "name": changeCase.camelCase(toName) + "Id",
                        "className": changeCase.pascalCase(toName) + "Id",
                        "isKey": false,
                        "namePascalCase": changeCase.pascalCase(toName) + "Id",
                        "nameCamelCase": changeCase.camelCase(toName) + "Id",
                        "isVO": true,
                        "label": "- "+ changeCase.camelCase(toName) + "Id: " + changeCase.pascalCase(toName) + "Id",
                        "referenceClass": changeCase.pascalCase(toName),
                    }
                }

                me.value.aggregateRoot.fieldDescriptors.forEach(function(field, idx) {
                    if(field.className.includes(attr.className)) {
                        field = attr
                        isNew = false
                    }
                })
                if(isNew) {
                    me.value.aggregateRoot.fieldDescriptors.push(attr);
                    // me.copyValue = me.value;
                }
                
            },
            deleteAggRelation(relation) {
                var me = this
                var aggField = relation.targetElement.name + "Id"

                var elementId;
                Object.values(me.value.aggregateRoot.entities.elements).forEach(function(el) {
                    if(el) {
                        if((el.isAggregateRoot || el.isVO) && aggField.includes(el.name)) {
                            elementId = el.elementView.id;
                        }
                    }
                })
                if(elementId 
                    && me.value.aggregateRoot.entities.elements[elementId] 
                    && !me.value.aggregateRoot.entities.elements[elementId].isAggregateRoot
                ) {
                    me.value.aggregateRoot.entities.elements[elementId] = null;
                }

                var relationId;
                Object.values(me.value.aggregateRoot.entities.relations).forEach(function(item) {
                    if(item) {
                        if(item.sourceElement.name == relation.sourceElement.name 
                            && (item.targetElement.name == aggField 
                                || item.targetElement.name == relation.targetElement.name)
                        ) {
                            relationId = item.relationView.id
                        }
                    }
                })
                if(relationId) {
                    me.value.aggregateRoot.entities.relations[relationId] = null;
                }

                var idx = -1;
                me.value.aggregateRoot.fieldDescriptors.forEach(function(attr, _idx) {
                    if(attr.className.includes(relation.targetElement.name)) {
                        idx = _idx
                    }
                })
                if(idx != -1) {
                    me.value.aggregateRoot.fieldDescriptors.splice(idx, 1);
                }
            },
            validate(panelValue, executeRelateToValidate){
                var me = this
                var notPK = false
                var duplicateField = false
                var executeValidate = executeRelateToValidate == false ? false :true
                var validateValue = me.propertyPanel && panelValue ? panelValue : me.value

                // Common
                this.$super(Element).validate()

                // execute Relate Validate
                if(executeValidate) {
                    //Event
                    if (me.canvasbase.attachedLists && me.canvasbase.attachedLists.eventLists) {
                        Object.values(me.canvasbase.attachedLists.eventLists).forEach(event => {
                            var eventComponent = me.canvasbase.$refs[`${event.elementView.id}`] ? me.canvasbase.$refs[`${event.elementView.id}`][0] : null
                            if (eventComponent) {
                                eventComponent.validate()
                                // eventComponent.validate(null, false)
                            }
                        })
                    }
                    //Command
                    if (me.canvasbase.attachedLists && me.canvasbase.attachedLists.commandLists) {
                        Object.values(me.canvasbase.attachedLists.commandLists).forEach(command => {
                            var commandComponent = me.canvasbase.$refs[`${command.elementView.id}`] ? me.canvasbase.$refs[`${command.elementView.id}`][0] : null
                            if (commandComponent) {
                                commandComponent.validate()
                                // commandComponent.validate(null, false)
                            }
                        })
                    }
                }

                //Element
                if(validateValue.name){
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_NAME))
                    if( validationResultIndex != -1 ){
                        me.elementValidationResults.splice(validationResultIndex,1)
                    }
                }else{
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_NAME) )
                    if( validationResultIndex == -1 ){
                        me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_NAME))
                    }
                }


                notPK = validateValue.aggregateRoot.fieldDescriptors.findIndex(fieldDescriptor => ( fieldDescriptor.isKey == true) ) == -1
                var filteredArray = validateValue.aggregateRoot.fieldDescriptors.filter(function(fieldDescriptor,index){
                    const fRules = (element,idx) => element.name.toLowerCase() == fieldDescriptor.name.toLowerCase()
                        && idx != index ;
                    return validateValue.aggregateRoot.fieldDescriptors.findIndex(fRules) == -1 ? false: true
                })

                if(filteredArray.length != 0 ){
                    duplicateField = true
                }


                if(notPK){
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_PK) )
                    if( validationResultIndex == -1 ){
                        me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_PK))
                    }
                }else{
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_PK))
                    if( validationResultIndex != -1 ){
                        me.elementValidationResults.splice(validationResultIndex,1)
                    }
                }

                if(duplicateField){
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_DUPLICATE_FIELD) )
                    if( validationResultIndex == -1 ){
                        me.elementValidationResults.push(me.validationFromCode(me.ESE_DUPLICATE_FIELD))
                    }
                }else{
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_DUPLICATE_FIELD))
                    if( validationResultIndex != -1 ){
                        me.elementValidationResults.splice(validationResultIndex,1)
                    }
                }

                me.canvasbase.changedTemplateCode = true
            }
        }
    }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .discStyle {
        list-style-type: disc;
    }
    .panel-title {
        font-size: 25px;
        color: #757575;
    }
</style>

